import { RESTAURANT_API_PATHS } from '../constants/apiPaths';
import axiosRestaurantInstance from '../restaurant/AxiosRestaurantInstance';
import { authHeaders } from '../restaurant/restaurantApi';

export const PRICING_FIELDS = Object.freeze([
  { key: 'base_fee', label: 'Base fee', help: 'Fixed amount per lunchbox trip' },
  { key: 'free_km', label: 'Free km', help: 'Home→hub distance included in base' },
  { key: 'per_km_fee', label: 'Per km fee', help: 'Charged after free km' },
  { key: 'hub_fee', label: 'Hub fee', help: 'Consolidation / sorting at hub' },
  { key: 'school_fee', label: 'School fee', help: 'Last-mile hub→school' },
  { key: 'transfer_fee', label: 'Transfer fee', help: 'Only for Route B (hub→hub)' },
  { key: 'cutoff_surcharge', label: 'Cutoff surcharge', help: 'When booked after pickup cutoff' },
]);

export const DEFAULT_PRICING_FORM = Object.freeze({
  base_fee: '50',
  free_km: '3',
  per_km_fee: '10',
  hub_fee: '20',
  school_fee: '25',
  transfer_fee: '30',
  cutoff_surcharge: '25',
  currency: 'INR',
  is_active: true,
});

export function emptyPricingForm() {
  return { ...DEFAULT_PRICING_FORM };
}

export function pricingRecordToForm(record) {
  if (!record) return emptyPricingForm();
  const form = emptyPricingForm();
  PRICING_FIELDS.forEach(({ key }) => {
    if (record[key] != null) form[key] = String(record[key]);
  });
  form.currency = record.currency || 'INR';
  form.is_active = record.is_active !== false;
  form.pricing_id = record.pricing_id ?? record.pricingId ?? null;
  form.hub_id = record.hub_id ?? record.hubId ?? null;
  form.scope = record.scope || (form.hub_id ? 'hub' : 'global');
  return form;
}

export function buildPricingPayload(form) {
  const payload = { currency: form.currency || 'INR', is_active: form.is_active !== false };
  PRICING_FIELDS.forEach(({ key }) => {
    const num = Number(form[key]);
    if (!Number.isFinite(num) || num < 0) {
      throw new Error(`${key} must be a non-negative number`);
    }
    payload[key] = num;
  });
  return payload;
}

export async function fetchGlobalPickupPricing() {
  const res = await axiosRestaurantInstance.get(RESTAURANT_API_PATHS.pickupPricing, {
    headers: authHeaders(),
  });
  return res?.data || null;
}

export async function saveGlobalPickupPricing(payload) {
  const res = await axiosRestaurantInstance.put(RESTAURANT_API_PATHS.pickupPricing, payload, {
    headers: authHeaders(),
  });
  return res?.data || null;
}

export async function fetchPickupHubs() {
  const res = await axiosRestaurantInstance.get(RESTAURANT_API_PATHS.pickupHubs, {
    headers: authHeaders(),
  });
  const data = res?.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.hubs)) return data.hubs;
  return [];
}

export async function bootstrapPickupHubsFromRestaurants() {
  const res = await axiosRestaurantInstance.post(
    RESTAURANT_API_PATHS.pickupHubsBootstrap,
    {},
    { headers: authHeaders() },
  );
  const data = res?.data || {};
  if (Array.isArray(data.hubs)) return data;
  return data;
}

export async function fetchHubPickupPricing(hubId) {
  const res = await axiosRestaurantInstance.get(RESTAURANT_API_PATHS.pickupHubPricing(hubId), {
    headers: authHeaders(),
  });
  return res?.data || null;
}

export async function saveHubPickupPricing(hubId, payload) {
  const res = await axiosRestaurantInstance.put(
    RESTAURANT_API_PATHS.pickupHubPricing(hubId),
    payload,
    { headers: authHeaders() },
  );
  return res?.data || null;
}

export async function quotePickupLunchbox(payload) {
  const res = await axiosRestaurantInstance.post(RESTAURANT_API_PATHS.pickupLunchboxQuote, payload, {
    headers: authHeaders(),
  });
  return res?.data || null;
}
